import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import IconButton from '@material-ui/core/IconButton';


//Action
import * as lightboxAction from '../action/lightboxAction';
//Add
import SwiperCore, { Navigation, Pagination, Lazy, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

//Icon
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
//Img
import Blank from '../img/blank/blank-1x1.gif';

import 'swiper/swiper.min.css';
import "swiper/swiper-bundle.min.css";

SwiperCore.use([Navigation, Pagination, Lazy, Scrollbar, A11y]);

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
  	}
  }


	render() {
		return (
			<div
				style={{
					position: "fixed",
				  top: "0",
				  left: "0",
				  height:"100%",
				  width: "100%",
				  margin: "0",
				  padding: "0",
				  zIndex: "5000",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
				}}
			>
        <div
          style={{
            maxWidth:'600px',
            margin:'auto',
            height:"100%",
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',

          }}
        >
					<div
						style={{
              height:"80px",
						}}
            align='right'
					>
            <IconButton
              onClick={ () => this.props.lightboxClose() }
            >
              <ClearRoundedIcon style={{fontSize:'2em', color:'#FFF'}} />
            </IconButton>
          </div>

					<div style={{flex:1, textAlign:'center'}}>
            <Swiper
              initialSlide={this.props.lightbox.photoIndex}
              spaceBetween={50}
              lazy={true}
              navigation={true}
              pagination={{ clickable: true }}
              onSlideChange={(e) => this.setState({activeIndex: e.activeIndex})}
              style={{width:'100%', height:'100%'}}
            >
              {
                this.props.lightbox.photoList.map((value, index) => (
                  <SwiperSlide key={index} style={{display: 'flex', justifyContent: 'center', position:'relative'}}>
                    <img
                      data-src={value.src}
                      className="swiper-lazy"
                      style={{
                        maxWidth: window.innerWidth - 20 + 'px',
                        maxHeight: window.innerHeight - 160 + 'px',
                        objectFit:'contain',
                      }}
                      alt=''
                    />
                    <img
                      src={Blank}
                      style={{
                        position: 'absolute',
                        left:0,
                        top:0,
                        width:'100%',
                        height:'100%',
                      }}
                      alt=''
                    />
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>
                ))
              }
            </Swiper>
					</div>

          <div
						style={{
              height:"80px",
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              overflow:'hidden'
						}}
					>
            {
              (this.props.lightbox.photoList[this.state.activeIndex].comment) && (
                <div style={{color:'#FFF', padding:'10px',fontSize:'0.9em'}}>{this.props.lightbox.photoList[this.state.activeIndex].comment}</div>
              )
            }

          </div>
        </div>
			</div>

		)
	}
}

const mapStateToProps = (state) => {
	return {
		lightbox: state.lightbox,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...lightboxAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
